/**
 * Depuración del playhead alineado pentagrama / mástil.
 *
 * En consola del navegador:
 *   localStorage.setItem('bordona:debugPlayhead', '1')
 *   location.reload()
 * Para desactivar:
 *   localStorage.removeItem('bordona:debugPlayhead')
 */

export function isPlayheadDebugEnabled(): boolean {
  if (typeof window === "undefined") return false;
  try {
    return window.localStorage.getItem("bordona:debugPlayhead") === "1";
  } catch {
    return false;
  }
}

export function logPlayhead(scope: string, payload: Record<string, unknown>): void {
  if (!isPlayheadDebugEnabled()) return;
  console.log(`[playhead:${scope}]`, payload);
}
